export const grey = {
  50: '#f9f9f9',
  100: '#f6f6f6',
  200: '#efefef',
  300: '#e5e5e5',
  400: '#cacaca',
  500: '#bcbcbc',
  600: '#666666',
  700: '#595959',
  800: '#444444',
  900: '#353535',
};
